(function () {
  const MQ = window.matchMedia('(max-width: 1024px)');

  function init() {
    if (!MQ.matches) return;

    const blocks = Array.from(document.querySelectorAll('.clay-for__item'));
    if (!blocks.length) return;

    const ENTER = '0.35s';
    const LEAVE = '0.25s';

    function openCard(block) {
      const content = block.querySelector('.clay-for__content');
      const desc    = block.querySelector('.clay-for__description');
      const image   = block.querySelector('.clay-for__image');
      if (content) content.style.gap = '0.5rem';
      if (desc)  { desc.style.transition = `opacity ${ENTER} ease, max-height ${ENTER} ease`; desc.style.opacity = '1'; desc.style.maxHeight = '200px'; }
      if (image) { image.style.transition = `opacity ${ENTER} ease, max-width ${ENTER} ease`;  image.style.opacity = '1'; image.style.maxWidth  = '105px'; }
    }

    function closeCard(block) {
      const content = block.querySelector('.clay-for__content');
      const desc    = block.querySelector('.clay-for__description');
      const image   = block.querySelector('.clay-for__image');
      if (content) content.style.gap = '0';
      if (desc)  { desc.style.transition = `opacity ${LEAVE} ease, max-height ${LEAVE} ease`; desc.style.opacity = '0'; desc.style.maxHeight = '0'; }
      if (image) { image.style.transition = `opacity ${LEAVE} ease, max-width ${LEAVE} ease`;  image.style.opacity = '0'; image.style.maxWidth  = '0'; }
    }

    const section = document.querySelector('.clay-for');
    if (!section) return;

    // How far from the bottom of the viewport a card top must be to "open"
    // e.g. 0.3 = card opens when its top crosses 70% down the viewport
    const OPEN_THRESHOLD = 0.2;

    // How far past section midpoint before cards start closing (% of sectionH)
    const CLOSE_START = 0; // 0 = exactly at midpoint, increase to delay closing

    // Gap between each card closing (% of sectionH)
    const CLOSE_GAP = 0.2;

    function onScroll() {
      const rect     = section.getBoundingClientRect();
      const sectionH = section.offsetHeight;
      const vpH      = window.innerHeight;

      const sectionMid   = rect.top + sectionH / 2;
      const vpCenter     = vpH / 2;
      const scrolledPast = vpCenter - sectionMid;

      blocks.forEach((block, index) => {
        const blockRect = block.getBoundingClientRect();
        const openLine  = vpH * (1 - OPEN_THRESHOLD);
        const closeAt   = (CLOSE_START + index * CLOSE_GAP) * sectionH;

        if (scrolledPast >= closeAt) {
          // Past close threshold — always close regardless of direction
          closeCard(block);
        } else if (blockRect.top < openLine) {
          // Before close threshold and card is visible — open
          openCard(block);
          if (blocks[index + 1]) openCard(blocks[index + 1]);
        } else {
          // Card hasn't entered view yet — keep closed
          closeCard(block);
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on init
  }

  document.addEventListener('DOMContentLoaded', init);
  MQ.addEventListener('change', init);
})();
